import API from "./index"

export const getGalleryImages = (page) => API.get(`/gallery/photos?page=${page}`)
export const createGalleryImage = (data) => API.post(`/gallery/photos`, data)
export const deleteGalleryImage = (id) => API.delete(`/gallery/photos/${id}`)


export const getGalleryVideos = (page) => API.get(`/gallery/videos?page=${page}`)
export const createGalleryVideo = (id) => API.post(`/gallery/videos`, {id})
export const deleteGalleryVideo = (link) => API.delete(`/gallery/videos/${link}`)